import ShareMenu from "./ShareMenu";

export default function ShareButton({ release, className = "" }) {
  return (
    <ShareMenu
      kind="music"
      slug={release.slug}
      title={release.title}
      text={`Listen to ${release.title} by DJ Código`}
      releaseId={release.internalId}
      eventType="share_song"
      className={className}
    />
  );
}
